import { styled } from '../../styles/settings/theme'

export const DiscordUsername = styled.h6`
  text-transform: none;
`
